import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";

export default function Dashboard() {
  return (
    <Container fluid className="page-section py-4">
      <Row className="mb-4">
        <Col>
          <h3 className="page-title">Admin Dashboard</h3>
          <p className="page-subtitle mb-0">
            Use the navigation to manage industries and trigger Gemini-powered report generation.
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={6} lg={4} className="mb-4">
          <Card>
            <Card.Body>
              <Card.Title>Next steps</Card.Title>
              <div className="card-divider" />
              <ul className="mb-0">
                <li>Add or edit the industries available to the reporting workflow.</li>
                <li>Generate a structured market report using Gemini.</li>
                <li>Review the output in the ElementalX reporting portal.</li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
